var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCreateDo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-create-do",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.049,
    height: 35.532,
    viewBox: "0 0 36.049 35.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document_editing",
    "data-name": "document editing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M28,16.9A1.506,1.506,0,0,0,29.51,15.4V8.732a1.512,1.512,0,0,0-.44-1.066L21.843.44A1.512,1.512,0,0,0,20.777,0H6.323A6.329,6.329,0,0,0,0,6.323V29.208a6.329,6.329,0,0,0,6.323,6.323H17.916A1.506,1.506,0,0,0,19.175,33.2,10.539,10.539,0,0,1,28,16.9Zm-15.056,11H6.926a1.506,1.506,0,0,1,0-3.011h6.022a1.506,1.506,0,1,1,0,3.011Zm2.481-7.624h-8.5a1.506,1.506,0,1,1,0-3.011h8.5a1.506,1.506,0,0,1,0,3.011ZM19.874,3.011h.277L26.5,9.359v.277H19.874Z",
    transform: "translate(0 0)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(20.476 18.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add",
    d: "M13.65,6.466H7.9V.718a.718.718,0,1,0-1.437,0V6.466H.718a.718.718,0,1,0,0,1.437H6.466V13.65a.718.718,0,0,0,1.437,0V7.9H13.65a.718.718,0,0,0,0-1.437Z",
    transform: "translate(0.602 0.602)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add_-_Outline",
    "data-name": "add - Outline",
    d: "M6.786-1A1.322,1.322,0,0,1,8.107.321V5.466h5.145a1.321,1.321,0,1,1,0,2.641H8.107v5.145a1.321,1.321,0,1,1-2.641,0V8.107H.321a1.321,1.321,0,0,1,0-2.641H5.466V.321A1.322,1.322,0,0,1,6.786-1Zm6.466,7.9a.116.116,0,1,0,0-.232H6.9V.321a.116.116,0,0,0-.232,0V6.67H.321a.116.116,0,0,0,0,.232H6.67v6.35a.116.116,0,1,0,.232,0V6.9Z",
    transform: "translate(1 1)",
    fill: "#ffffff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateDo);
export default __webpack_public_path__ + "static/media/icon-create-do.4f037a882e8cfb393718ada0098fea0f.svg";
export { ForwardRef as ReactComponent };